import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ActivationEnd, Router } from "@angular/router";
import { ApsServiceService } from "../aps-service.service";

@Component({
  selector: "app-collecting",
  templateUrl: "./collecting.component.html",
  styleUrls: ["./collecting.component.css"],
})
export class CollectingComponent implements OnInit {
  loaderdata: any = false;
  dataexist: any = false;
  data: any = "";
  pages: any = "";
  next: any = "";
  previous: any = "";
  first: any = "";
  last: any = "";
  limit: any = 6;
  eventspage: any = "";
  eventpagenumber: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private searchitem: ApsServiceService
  ) {}

  ngOnInit(): void {
    this.getarticletlist();
    this.router.events.subscribe((event) => {
      //console.log(event)
      //  this.geeventlist();

      if (event instanceof ActivationEnd) {
        //console.log("navigation start");
        this.getarticletlist();
      }
    });
  }

  getarticletlist() {
    this.loaderdata = true;
    this.eventpagenumber = this.route.snapshot.params.page;
    //console.log(this.eventpagenumber)
    this.searchitem
      .getcollect(this.eventpagenumber, this.limit)
      .subscribe((responce) => {
        if (responce.status) {
          this.dataexist = true;
          this.pages = parseInt(responce.totalitems);
          this.last = Math.ceil(this.pages / this.limit);

          if (responce.next) {
            this.next = parseInt(responce.next);
          } else {
            this.next = 0;
          }
          if (responce.previous) {
            this.previous = parseInt(responce.previous);
          } else {
            this.previous = 0;
          }

          //console.log(responce.totalitems)
          //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);
          this.data = responce.data;
        } else {
          this.dataexist = false;
        }
        this.loaderdata = false;
      });

    //console.log('data is',this.data)
  }
}
